import TimeSheetTabContent from './TimeSheetTabContent';

const LitigationContent = () => (
  <TimeSheetTabContent status="2" emptyStateType="time_sheet_litigation" showStatusColumn />
);

export default LitigationContent;
